import { makeStyles } from '@material-ui/core/styles';
import image from '../img/bg7.jpg';

export const useStyles = makeStyles((theme) => ({
  container: {
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    alignContent: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100vw',
  },
  avatar: {
    margin: '5px auto',
    color: theme.palette.secondary.main,
    backgroundColor: 'white',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formContent: {
    margin: '5px 0',
  },
  formInput: {
    marginLeft: '10px',
  },
  icon: {
    color: '#757575',
  },
}));
